import { Link, useLocation } from 'react-router';
import { Alert } from '@/components/ui/alert';
import { useContact } from '@/features/settings/useSiteSettings';

const TITLES: Record<string, string> = {
  '/aszf': 'Általános Szerződési Feltételek',
  '/adatvedelem': 'Adatkezelési tájékoztató',
  '/cookie': 'Cookie-tájékoztató'
};

export const LegalPage = () => {
  const contact = useContact();
  const location = useLocation();
  const title = TITLES[location.pathname] ?? 'Jogi tájékoztató';

  return (
    <div className="mx-auto w-full max-w-[840px] px-4 py-14 sm:px-6">
      <h1 className="text-2xl">{title}</h1>

      <Alert tone="info" title="A dokumentum még készül" className="mt-8">
        <p>
          A végleges szöveg jogi egyeztetés alatt áll, és amint elkészül, itt lesz olvasható. Addig is
          minden kérdésére szívesen válaszolunk telefonon:{' '}
          <a href={contact.phoneHref} className="font-semibold text-teal-ink">
            {contact.phone}
          </a>
        </p>
      </Alert>

      <Link
        to="/"
        className="mt-8 inline-flex min-h-12 items-center rounded-md border-2 border-navy px-6 font-semibold text-navy no-underline hover:bg-navy hover:text-cream"
      >
        Vissza a főoldalra
      </Link>
    </div>
  );
};
